<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="mb-0"><i class="fa fa-clipboard mr-2" />Planner</h4>
                    <div class="text-right">
                        <router-link v-if="isAddAllowed" to="/plan/create">
                            <b-button variant="dark">
                                <i class="fa fa-plus mr-2" />Plan Baru
                            </b-button>
                        </router-link>
                    </div>
                </div>
                <hr />
                <b-row>
                    <b-col md="3">
                        <b-form-group label="Nomor Plan">
                            <b-form-input v-model="filter.no" type="search" @keydown.enter="getItems" />
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Nomor DO">
                            <b-form-input v-model="filter.noDo" type="search" @keydown.enter="getItems" />
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Status">
                            <b-form-select v-model="filter.status" :options="optStatus">
                                <template v-slot:first>
                                    <b-form-select-option value=-1>Semua</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="2">
                        <b-form-group label="Wilayah Tujuan">
                            <multiselect v-model="filter.wilayah"
                                :options="optWilayah"
                                :allow-empty="true"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="id"
                                placeholder="Wilayah"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Lokasi Tujuan">
                            <multiselect v-model="filter.lokasi"
                                :disabled="filter.wilayah == null"
                                :options="optLokasi"
                                :allow-empty="true"
                                :internal-search="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="id"
                                placeholder="Lokasi"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="search-wrapper d-flex align-items-center mb-3">
                    <b-button variant="primary" class="mr-2" @click="getItems">
                        <i class="fa fa-search mr-2" /> Search
                    </b-button>
                    <b-button variant="danger" @click="resetSearch">
                        <i class="fa fa-times mr-2" /> Reset Search
                    </b-button>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada plan.
                    </template>
                    <template v-slot:cell(no)="row">
                        {{ row.item.no }}
                        <div class="small text-muted">{{ row.item.noDo }}</div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                    </template>
                    <template v-slot:cell(tujuan)="row">
                        {{ row.item.lokasi }}
                        <div class="small text-muted">{{ row.item.wilayah }}</div>
                    </template>
                    <template v-slot:cell(createdAt)="row">
                        {{ $helper.parseDate(row.item.createdAt) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                    </template>
                    <template v-slot:cell(action)="row">
                        <router-link :to="'/plan/' + row.item.id">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail">
                                <i class="fa fa-fw fa-search" />
                            </b-button>
                        </router-link>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :totalRows="totalRows"
                        :per-page="perPage"
                        @change="onPageChange"
                    />
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    name: 'plan-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            filter: {
                no: "",
                noDo: "",
                status: -1,
                wilayah: null,
                lokasi: null
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No. Plan / DO" },
                { key: "status", label: "Status" },
                { key: "tujuan", label: "Tujuan" },
                { key: "createdAt", label: "Tanggal Pembuatan" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optWilayah: [],
            optLokasi: [],
            optStatus: [
                { value: 1, text: "Persiapan" },
                { value: 2, text: "Instalasi" },
                { value: 3, text: "Selesai" },
                { value: 0, text: "Batal" }
            ]

        }
    },
    computed: {

        isAddAllowed() {
            return [0, 1, 7, 8, 10].includes(this.$helper.getRoleId())
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            let getWilayah = this.$axios.get("wilayah/selection").then(res => {
                this.optWilayah = res.data
            })

            let getItems = this.getItems()

            Promise.all([getWilayah, getItems]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.noDo)) {
                param += "&filterNoDo=" + this.filter.noDo
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(!this.$helper.isBlank(this.filter.lokasi)) {
                param += "&filterLokasi=" + this.filter.lokasi.id
            }
            else if(!this.$helper.isBlank(this.filter.wilayah)) {
                param += "&filterWilayah=" + this.filter.wilayah.id
            }

            // Execute
            return this.$axios.get("plan/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        resetSearch() {

            this.filter.no = ""
            this.filter.noDo = ""
            this.filter.status = -1
            this.filter.wilayah = null
            this.filter.lokasi = null
            this.getItems()

        },

        parseStatusBadge(status) {

            switch(status) {
                case "BATAL": return "danger"
                case "PERSIAPAN": return "dark"
                case "INSTALASI": return "primary"
                case "SELESAI": return "success"
                default: return "light"
            }

        }

    },
    watch: {

        "filter.wilayah": function(newVal) {

            this.filter.lokasi = null

            if(newVal == null) {
                return
            }

            let append = ""
            if([0, 7, 8, 10].includes(this.$helper.getRoleId())) {
                append = "?all=true"
            }

            this.$axios.get("lokasi/selection/" + newVal.id + append).then(res => {
                this.optLokasi = res.data
            })

        }

    },
    created() {
        this.init()
    }
}
</script>
